<template>
    <div id="app_high">
        <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
        <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
        <!-- <div class="box"> -->
        <resource-highschool />
        <!-- </div> -->
    </div>
</template>
  
<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
    name: "app_high",
    components: {
        // HelloWorld
    },
    data() {
        return {};
    },
    mounted() {
    },

};
</script>
  
<style >
#app_high {
  width: 100vw;
  /* height: 100vh; */
  background-color: #f6f6f6;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 14px;
}

#app_high .flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
#app_high .flex_fss {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
#app_high .flex_fs {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
#app_high .flex_fe {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
#app_high .flexs {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
#app_high .flexe {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
#app_high .flexc {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

#app_high .flexcs {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

#app_high .flexcc {
  display: flex;
  justify-content: center;
  align-items: center;
}

#app_high .flexcsc {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
#app_high .flex-shink {
  flex-shrink: 0;
}

#app_high .flex_column {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

#app_high .martop24 {
  margin-top: 24px;
}
#app_high .martop20 {
  margin-top: 20px;
}
#app_high .martop10 {
  margin-top: 10px;
}
#app_high .marleft12 {
  margin-left: 12px;
}
#app_high .marleft20 {
  margin-left: 20px;
}
#app_high .mar_left20 {
  margin-left: -20px;
}
</style>
  